<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'menu.employees' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCloseClick()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div *ngFor="let user of data" class="user">{{ user }}</div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCloseClick()">Close</button>
  </footer>
</div>
